import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { addUnsavedWork, markWorkSaved } from '../actions/unsavedwork'

export default (hasUnsavedWork, workId, safePath, isInModal) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (hasUnsavedWork) {
      dispatch(addUnsavedWork(workId, safePath, isInModal))

      return () => {
        dispatch(markWorkSaved(workId))
      }
    }
  }, [hasUnsavedWork, workId, safePath, isInModal])
}
